import { render, staticRenderFns } from "./LoanDisbursement.vue?vue&type=template&id=812cc4c4"
import script from "./LoanDisbursement.vue?vue&type=script&lang=js"
export * from "./LoanDisbursement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports